import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        overflow: 'auto',
        overflowX: 'hidden',
        flex: 1,
    },
}));
/**
 * DrawerContent component for the Drawer.
 *
 * This component renders the content for the Drawer.
 * The content can contain any content, such as text or form fields.
 *
 * @param {DrawerContentProps} props
 */
export const DrawerContent = ({ children, ...props }) => {
    const classes = useStyles();
    return (_jsx("div", { className: clsx(classes.root, props.className), "data-testid": 'drawer-content', ...props, children: children }));
};
